import React from 'react';
import { Instagram, Mail, MapPin } from 'lucide-react';
import { WhatsAppIcon } from '../WhatsAppIcon';
import { siteConfig } from '../../data/mock';

const linkClass = 'flex items-center gap-3 text-[#b8b8b8] hover:text-[#c9a87c] transition-colors';

export const AboutStory = () => (
  <section className="section-spacing bg-[#121212]" data-testid="about-story">
    <div className="revolt-container">
      <div className="max-w-3xl mx-auto">
        <h1 className="section-title text-center mb-8">About Me</h1>
        <div className="about-portrait" data-testid="about-portrait">
          <img src={siteConfig.aboutImage} alt="Elina K., family and newborn photographer in Dubai, holding her camera" />
        </div>
        <p className="about-text text-center">
          My name is Elina. I've loved photography for as long as I can remember,
          and after becoming a mother, I found my way back to it.
        </p>
        <p className="about-text text-center">
          For me, photography is about keeping the moments that feel ordinary today,
          but may become some of the most meaningful ones later. A photograph lets us
          return to a certain day, remember how it felt, and experience those happy
          memories again.
        </p>
        <p className="about-text text-center">
          Originally from Ukraine, I've lived in Dubai since 2019. I'm a mother,
          a wife and a dog lover. I love to travel and dream of photographing people
          and their stories in different corners of the world.
        </p>

        <div className="mt-12 flex flex-col items-center gap-4">
          <a href={`mailto:${siteConfig.email}`} className={linkClass} data-testid="about-email-link">
            <Mail className="w-5 h-5" />
            {siteConfig.email}
          </a>
          <a
            href={`https://instagram.com/${siteConfig.instagram.replace('@', '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
            data-testid="about-instagram-link"
          >
            <Instagram className="w-5 h-5" />
            {siteConfig.instagram}
          </a>
          <a
            href={`https://wa.me/${siteConfig.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
            data-testid="about-whatsapp-link"
          >
            <WhatsAppIcon className="w-5 h-5" />
            {siteConfig.phone}
          </a>
          <div className="flex items-center gap-3 text-[#b8b8b8]">
            <MapPin className="w-5 h-5" />
            {siteConfig.location}
          </div>
        </div>
      </div>
    </div>
  </section>
);
